import { render, staticRenderFns } from "./ButtonEdit.vue?vue&type=template&id=2d210ce6&scoped=true&"
import script from "./ButtonEdit.vue?vue&type=script&lang=js&"
export * from "./ButtonEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d210ce6",
  null
  
)

export default component.exports